module.exports = __webpack_public_path__ + "static/media/name.61d34c7a.svg";